import { FormattedMessage, useIntl } from "react-intl";
import { Box, Button, Grid } from "@material-ui/core";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import AppAnimate from "../../components/ui/AppAnimate/AppAnimate";
import { CustomizedSearch } from "../../components/custom/CustomizedSearch";
import { FormEntity } from "../../components/super-admin/FormEntity";
import CustomizedDialog from "../../components/custom/CustomizedDialog";
import { MyAlert } from "../../components/custom/MyAlert";
import { EntitiesTable } from "../../components/super-admin/EntitiesTable";
import { useStyles } from "../../shared/styles/useStyles";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducers/rootReducer";
import {
  uiCloseModalAdd,
  uiCloseModalDelete,
  uiCloseModalEdit,
  uiCloseSuccessAlert,
  uiOpenModalAdd,
} from "../../redux/actions/uiActions";
import { useState } from "react";
import { purgeActiveEntity } from "../../redux/actions/entitiesActions";

export const EntitiesScreen = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [add, setAdd] = useState(false);
  const { modalAddOpen, modalEditOpen, modalDeleteOpen } = useSelector(
    (state: AppState) => state.ui
  );
  const { entities } = useSelector((state: AppState) => state.entities);
  const { successAlert } = useSelector((state: AppState) => state.ui);
  const onAdd = () => {
    dispatch(uiOpenModalAdd());
    setAdd(true);
  };
  // Cerrar modal crear entidad
  const onDenyAdd = () => {
    setAdd(false);
    dispatch(uiCloseModalAdd());
  };

  // Cerra modal editar entidad
  const onDenyEdit = () => {
    dispatch(uiCloseModalEdit());
    dispatch(purgeActiveEntity());
  };

  // Cerrar modal eliminar entidad
  const onDenyDelete = () => {
    dispatch(uiCloseModalDelete());
  };

  return (
    <AppAnimate animation="transition.slideUpIn" delay={200}>
      <Box>

        <Box mb={3} fontSize={20}>
          <Grid container>
            <Grid item xs={5}>
              <Button
                size="large"
                variant="contained"
                color="secondary"
                className={classes.btnAdd}
                type="button"
                onClick={onAdd}
              >
                <AddOutlinedIcon />
                <FormattedMessage id="CreateNewEntity" />
              </Button>
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={5}>
              <CustomizedSearch data={entities} />
            </Grid>
          </Grid>
        </Box>
        {<EntitiesTable />}
        <CustomizedDialog
          open={modalAddOpen}
          cancelBtn={true}
          onDeny={onDenyAdd}
          title={`${intl.formatMessage({ id: "CreateNewEntity" })}`}
          content={<FormEntity />}
          width
          textButton="Accept"
        />
        <CustomizedDialog
          open={modalEditOpen}
          cancelBtn={true}
          onDeny={onDenyEdit}
          title={`${intl.formatMessage({ id: "EditEntity" })}`}
          content={<FormEntity edit />}
          width
          textButton="Accept"
        />
        <CustomizedDialog
          open={modalDeleteOpen}
          cancelBtn={true}
          onDeny={onDenyDelete}
          title={`${intl.formatMessage({ id: "DeleteEntity" })}`}
          content={
            <>
              {" "}
              <h1>BORRAR ENTIDAD</h1>{" "}
            </>
          }
          seeActions
          textButton="Accept"
        />
        <MyAlert
          open={successAlert}
          typeAlert="success"
          message={!add ? "UpdatedEntity" : "SavingEntitySuccess"}
          time={2000}
          handleClose={() => dispatch(uiCloseSuccessAlert())}
        />
      </Box>
    </AppAnimate>
  );
};
